// styles
import './Box.css';

const Box = ({ children }) => {
	return <div className="box">{children}</div>;
};

export default Box;
